export class SnapshotFilterConditions {
    'pointInTime';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "SnapshotDateFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
